module.exports = __webpack_public_path__ + "static/media/PeripartumMainNav.2341aaac.jpg";